"use client";

import { Icons } from "@/components/icons";
import { BorderText } from "@/components/ui/border-number";
import { siteConfig } from "@/lib/config";
import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export function Footer() {
  const { theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // After mounting, we have access to the theme
  useEffect(() => setMounted(true), []);

  // This is backwards from what you might expect - we want light logo on dark background
  // and dark logo on light background (for better contrast)
  const spectrumLogoSrc = mounted && theme === "dark" ? "/spectrumwebco-light.png" : "/spectrumwebco-dark.png";

  return (
    <footer className="flex flex-col gap-y-5 rounded-lg px-7 py-5 container max-w-full mt-auto border-t">
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="flex items-center gap-x-2">
          <div className="w-48 h-12 relative">
            <Image 
              src={spectrumLogoSrc}
              alt="Spectrum Web Co"
              fill
              style={{ objectFit: 'contain' }}
              priority
            />
          </div>
        </div>

        <div className="flex gap-x-6 mt-4">
          {siteConfig.footer.socialLinks.map((link, index) => (
            <Link
              key={index}
              href={link.url}
              className="flex h-8 w-8 items-center justify-center text-muted-foreground transition-all duration-100 ease-linear hover:text-foreground hover:scale-110"
              aria-label={link.name}
            >
              {link.icon}
            </Link>
          ))}
        </div>
        
        <ul className="flex gap-x-6 gap-y-2 text-muted-foreground mt-4 md:items-center">
          {siteConfig.footer.links.map((link, index) => (
            <li
              key={index}
              className="text-[15px]/normal font-medium text-muted-foreground transition-all duration-100 ease-linear hover:text-foreground hover:underline hover:underline-offset-4"
            >
              <a href={link.url}>{link.text}</a>
            </li>
          ))}
        </ul>
        
        <div className="flex items-center justify-center text-sm font-medium tracking-tight text-muted-foreground mt-4">
          <p>{siteConfig.footer.bottomText}</p>
        </div>
      </div>
      
      <div className="bg-gradient-to-b from-gray-700 to-emerald-500 bg-clip-text text-transparent">
        <BorderText
          text={siteConfig.footer.brandText}
          className="text-[clamp(4rem,18vw,12rem)] overflow-hidden font-mono tracking-tighter font-medium"
        />
      </div>
    </footer>
  );
}
